module.exports = __webpack_public_path__ + "img/navlogoEn.7bd0e799.png";